// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#save-success-text {
  text-align: center;
  font-weight: 600;
  color: var(--colour-primary);
}`, "",{"version":3,"sources":["webpack://./src/app/components/save-success-modal/save-success-modal.component.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;EACA,gBAAA;EACA,4BAAA;AACJ","sourcesContent":["#save-success-text {\r\n    text-align: center;\r\n    font-weight: 600;\r\n    color: var(--colour-primary);\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
